import { Modal, Text, Anchor, Stack, Title } from "@mantine/core";
import { useAppStore } from "../store/appStore";

export function SatelliteInfoModal() {
  const { satelliteInfoOpen, closeSatelliteInfo } = useAppStore();

  return (
    <Modal
      opened={satelliteInfoOpen}
      onClose={closeSatelliteInfo}
      title={
        <Text fw={600}>
          33 years of globally calibrated wave height and wind speed data based
          on altimeter observations
        </Text>
      }
      size="xl"
      scrollAreaComponent={undefined}
    >
      <Stack gap="md">
        <Title order={5}>Description</Title>
        <Text size="sm" ta="justify">
          This dataset consists of 33 years (1985 to 2018), of global
          significant wave height and wind speed obtained from 13 altimeters,
          namely: GEOSAT, ERS-1, TOPEX, ERS-2, GFO, JASON-1, ENVISAT, JASON-2,
          CRYOSAT-2, HY-2A, SARAL, JASON-3 and SENTINEL-3A. The altimeter data
          have been calibrated and validated against National Oceanographic Data
          Center (NODC) buoy data. Differences between altimeter and buoy data
          as a function of time are investigated for long-term stability. A
          cross validation between altimeters is also carried out in order to
          check the stability and consistency of the calibrations developed.
          Quantile-quantile comparisons between altimeter and buoy data as well
          as between altimeters are undertaking to test consistency of
          probability distributions and extreme value performance. All data is
          quality controlled. This globally calibrated and cross-validated
          dataset provides a single point of storage for all altimeter missions
          in a consistent format.
        </Text>
        <Text size="xs" c="dimmed">
          <Anchor
            href="https://www.nature.com/articles/s41597-019-0083-9"
            target="_blank"
            size="xs"
          >
            Ribal, Agustinus; Young, Ian (2019): 33 years of globally
            calibrated wave height and wind speed data based on altimeter
            observations. DOI: 10.26198/5c77588b32cc1
          </Anchor>
        </Text>
      </Stack>
    </Modal>
  );
}
